import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { SurvivorView } from './SurvivorView'

const WrappedSurvivorView = withLayout(LayoutType.Default, SurvivorView)

export { WrappedSurvivorView as SurvivorView }
